import React from "react";
import { Link } from "react-router-dom";
import Section from "../components/Section";
import Panel from "../components/Panel";

const Records = ({ records, url }) => {
	const sortedRecords = [...records].sort((a, b) =>
		a.title.localeCompare(b.title)
	);
	return (
		<>
			<Section title="Incomplete">
				{sortedRecords
					.filter((record) => !record.completed)
					.map(({ _id, title }, index) => (
						<Link
							key={`record-incomplete-${index}`}
							to={`${url}/record/${_id}`}
						>
							<Panel>
								<Panel.Title>{title}</Panel.Title>
							</Panel>
						</Link>
					))}
			</Section>
			<Section title="Complete">
				{sortedRecords
					.filter((record) => record.completed)
					.map(({ _id, title }, index) => (
						<Link
							key={`record-complete-${index}`}
							to={`${url}/record/${_id}`}
						>
							<Panel>
								<Panel.Title>{title}</Panel.Title>
							</Panel>
						</Link>
					))}
			</Section>
		</>
	);
};

export default Records;
